import home from "@/view/admin/home/index.vue"; //数据分析
import layout from "@/layout/index.vue";
import warningPersonnel from "@/view/admin/warningPersonnel/index.vue"; // 预警人员
import organizational from "@/view/admin/organizational/index.vue"; //组织架构
import unitReport from "@/view/admin/unitReport/index.vue"; // 单位报告
import userManagement from "@/view/admin/userManagement/index.vue"; //用户管理
import mobileCarousel from "@/view/admin/mobileCarousel/index.vue"; //手机轮播
import xinkangDoctor from "@/view/admin/xinkangDoctor/index.vue"; //心康医生
import doctor from "@/view/admin/doctor/index.vue"; //医生
import doctorList from "@/view/admin/doctor/doctorList/index.vue"; //咨询师列表
import packageManage from "@/view/admin/doctor/packageManage/index.vue"; //咨询师服务项目
import qualificationCertification from "@/view/admin/doctor/qualificationCertification/index.vue"; //咨询师资质认证
import ConsultantScheduling from "@/view/admin/doctor/ConsultantScheduling/index.vue"; //咨询师排班
import psychometrics from "@/view/admin/psychometrics/index.vue"; //心理测评
import psychometricsManage from "@/view/admin/psychometrics/manage/index.vue"; //测评管理
import psychometricsClassification from "@/view/admin/psychometrics/classification/index.vue"; //测评分类
import popularization from "@/view/admin/popularization/popularization.vue"; //心理科普
import classroom from "@/view/admin/classroom/index.vue"; //心理课堂
import courseEdit from "@/view/admin/classroom/courseEdit/index.vue"; //课程管理
import courseOrder from "@/view/admin/classroom/courseOrder/index.vue"; //课程订单
import courseclassification from "@/view/admin/classroom/courseclassification/index.vue"; //课程分类
import homeConfig from "@/components/dataConfig/homeConfig.vue"; //数据分析-综合结果
import homeConfigResult from "@/components/resultConfig/homeConfigResult.vue"; //数据分析-综合结果2
import somatization from "@/components/somatizationConfig/somatization.vue"; //躯体化
import activityManagement from "@/view/admin/activityManagement/index.vue"; //活动管理
import device from "@/view/admin/device/index.vue"; //设备管理
import testHistory from "@/view/admin/testHistory/index.vue"; //测评历史
import taskList from "@/view/admin/taskList/index.vue"; //下载列表
import warningWorkOrder from "@/view/admin/warningWorkOrder/index.vue"; //预警工单管理
import monitoringBigData from "@/view/admin/monitoringBigData/index.vue"; //监控大数据
import realTimeAlert from "@/view/admin/realTimeAlert/index.vue"; //动态检测结果
import scaleManagement from "@/view/admin/scaleManagement/index.vue"; //量表管理
import articleManagement from "@/view/admin/articleManagement/index.vue"; //文章管理
import hikvisionEvaluationPersonnel from "@/view/admin/hikvisionEvaluationPersonnel/index.vue"; //动态评测人员
// 需要权限的路由
export const authRoutes = [
  {
    path: "/home",
    name: "home",
    component: home,
    meta: {
      title: "数据分析",
      icon: "shujufenxi",
    },
  },
  {
    path: "/monitoringBigData",
    name: "monitoringBigData",
    component: monitoringBigData,
    meta: {
      title: "监控大数据",
      icon: "shujufenxi",
    },
  },
  {
    path: "/warningPersonnel",
    name: "warningPersonnel",
    component: warningPersonnel,
    meta: {
      title: "预警人员",
      icon: "yujingryuan",
    },
  },
  {
    path: "/warningWorkOrder",
    name: "warningWorkOrder",
    component: warningWorkOrder,
    meta: {
      title: "预警工单管理",
      icon: "yujingryuan",
    },
  },
  {
    path: "/testHistory",
    name: "testHistory",
    component: testHistory,
    meta: {
      title: "评测历史",
      icon: "history",
    },
  },
    {
    path: "/realTimeAlert",
    name: "realTimeAlert",
    component: realTimeAlert,
    meta: {
      title: "动态检测结果",
      icon: "history",
    },
  },
  {
    path: "/taskList",
    name: "taskList",
    component: taskList,
    meta: {
      title: "下载中心",
      icon: "xzzx",
    },
  },
  {
    path: "/unitReport",
    name: "unitReport",
    component: unitReport,
    meta: {
      title: "单位报告",
      icon: "danweibaogao",
    },
    children: [],
  },
  {
    path: "/userManagement",
    name: "userManagement",
    component: userManagement,
    meta: {
      title: "评测人员",
      icon: "yonghuguanli",
      type: 1,
    },
    children: [],
  },
  {
    path: "/hikvisionEvaluationPersonnel",
    name: "hikvisionEvaluationPersonnel",
    component: hikvisionEvaluationPersonnel,
    meta: {
      title: "动态评测人员",
      icon: "yonghuguanli",
      type: 1,
    },
    children: [],
  },
  {
    path: "/activityManagement",
    name: "activityManagement",
    component: activityManagement,
    meta: {
      title: "活动管理",
      icon: "huodongguanli",
    },
  },
  {
    path: "/device",
    name: "device",
    component: device,
    meta: {
      title: "设备管理",
      icon: "xitongshezhi",
    },
  },
  {
    path: "/mobileCarousel",
    name: "mobileCarousel",
    component: mobileCarousel,
    meta: {
      title: "手机轮播",
      icon: "shoujilunbo",
    },
    children: [],
  },
  {
    path: "/scaleManagement",
    name: "scaleManagement",
    component: scaleManagement,
    meta: {
      title: "量表管理",
      icon: "shoujilunbo",
    },
    children: [],
  },
    {
    path: "/articleManagement",
    name: "articleManagement",
    component: articleManagement,
    meta: {
      title: "文章管理",
      icon: "shoujilunbo",
    },
    children: [],
  },
  {
    path: "/xinkangDoctor",
    name: "xinkangDoctor",
    component: xinkangDoctor,
    meta: {
      title: "心康医生",
      icon: "xinkangyisheng",
    },
    children: [],
  },
  {
    path: "/doctor",
    name: "doctor",
    component: doctor,
    meta: {
      title: "医生列表",
      icon: "yishengliebiao",
    },
    children: [
      {
        path: "/doctor/doctorList",
        name: "doctorList",
        component: doctorList,
        meta: {
          title: "医生维护",
        },
      },
      {
        path: "/doctor/packageManage",
        name: "packageManage",
        component: packageManage,
        meta: {
          title: "服务项目",
        },
      },
      {
        path: "/doctor/qualificationCertification",
        name: "qualificationCertification",
        component: qualificationCertification,
        meta: {
          title: "资质认证",
        },
      },
      {
        path: "/doctor/ConsultantScheduling",
        name: "ConsultantScheduling",
        component: ConsultantScheduling,
        meta: {
          title: "咨询师排班",
        },
      },
    ],
  },
  {
    path: "/psychometrics",
    name: "psychometrics",
    component: psychometrics,
    meta: {
      title: "心理测评",
      icon: "xinliceping",
    },
    children: [
      {
        path: "/psychometrics/manage",
        name: "psychometricsManage",
        component: psychometricsManage,
        meta: {
          title: "测评管理",
        },
      },
      {
        path: "/psychometrics/classification",
        name: "psychometricsClassification",
        component: psychometricsClassification,
        meta: {
          title: "分类维护",
        },
      },
    ],
  },
  // {
  //   path: "/popularization",
  //   name: "popularization",
  //   component: popularization,
  //   meta: {
  //     title: "心理科普",
  //     icon: "xinlikepu",
  //   },
  //   children: [],
  // },
  {
    path: "/classroom",
    name: "classroom",
    component: classroom,
    meta: {
      title: "心理课堂",
      icon: "xinliketang",
    },
    children: [
      {
        path: "/classroom/courseEdit",
        name: "courseEdit",
        component: courseEdit,
        meta: {
          title: "课程管理",
        },
      },
      {
        path: "/classroom/courseOrder",
        name: "courseOrder",
        component: courseOrder,
        meta: {
          title: "课程订单",
        },
      },
      {
        path: "/classroom/courseclassification",
        name: "courseclassification",
        component: courseclassification,
        meta: {
          title: "课程分类",
        },
      },
    ],
  },
  {
    path: "/organizational",
    name: "organizational",
    component: organizational,
    meta: {
      title: "用户管理",
      icon: "zuzhijiagou",
      type: 1,
    },
  },
  //数据分析-综合结果
  {
    path: "/homeConfig",
    name: "homeConfig",
    component: homeConfig,
  },
  {
    path: "/homeConfigResult",
    name: "homeConfigResult",
    component: homeConfigResult,
  },
  // 躯体化
  {
    path: "/somatization",
    name: "somatization",
    component: somatization,
  },
];
let text="/login"
if(window.global_config.LoginType === 0){
   text="/login"
}
if(window.global_config.LoginType === 1){
   text="/AiVideo"
}
if(window.global_config.LoginType === 2){
   text="new_AiVideo"
}
export default [
  {
    path: "/",
    redirect: text,
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/view/auth/login/index.vue"),
  },
  {
    path: "/AiVideo",
    name: "AiVideo",
    component: () => import("@/view/auth/AiVideo/index.vue"),
    meta: {
      noNeedToken: true,
    }
  },
  {
    path: "/new_AiVideo",
    name: "new_AiVideo",
    component: () => import("@/view/auth/new_AiVideo/index.vue"),//新页面
    meta: {
      noNeedToken: true,
    }
  },
  {
    path: "/addTester",
    name: "addTester",
    component: () => import("@/view/auth/AiVideo/h5/addTester.vue"),
    meta: {
      title: "扫码登录",
      noNeedToken: true,
    },
  },
  {
    path: "/AiVideo/home",
    name: "AiHome",
    component: () => import("@/view/auth/AiVideo/home.vue"),
    meta: {
      title: "视频采集",
    },
  },
  {
    path: "/AiVideo/report",
    name: "AiReport",
    component: () => import("@/view/auth/AiVideo/report.vue"),
    meta: {
      title: "报告详情",
    },
  },
    {
    path: "/new_AiVideo/report",
    name: "new_AiReport",
    component: () => import("@/view/auth/new_AiVideo/report.vue"),
    meta: {
      title: "报告详情",
    },
  },
  {
    path: "/home",
    name: "admin",
    component: layout,
  },
];
